// ─── Enums ──────────────────────────────────────────────────────────────────
export var EnumPartnerType;
(function (EnumPartnerType) {
    EnumPartnerType["pony"] = "form.partnerType.pony";
    EnumPartnerType["horse"] = "form.partnerType.horse";
    EnumPartnerType["owner"] = "form.partnerType.owner";
    EnumPartnerType["other"] = "form.partnerType.other";
})(EnumPartnerType || (EnumPartnerType = {}));
//# sourceMappingURL=partner.js.map